var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GoogleMapLoader',{ref:"mapLoader",attrs:{"mapConfig":_vm.mapConfig,"apiKey":_vm.keyMap,"markers":_vm.markers},on:{"ready":_vm.handleMapIsReady},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var google = ref.google;
var map = ref.map;
return _vm._l((_vm.markers),function(marker){return _c('GoogleMapMarker',{key:marker.id,attrs:{"marker":marker,"google":google,"map":map},on:{"click":_vm.handleMarkerClick}})})}}])})}
var staticRenderFns = []

export { render, staticRenderFns }